exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, "#dashboard[data-v-5e3b1b97] {\n  min-height: 70vh;\n}\n.fade-enter-active[data-v-5e3b1b97],\n.fade-leave-active[data-v-5e3b1b97] {\n  -webkit-transition: opacity 0.3s;\n  -moz-transition: opacity 0.3s;\n  -ms-transition: opacity 0.3s;\n  -o-transition: opacity 0.3s;\n  transition: opacity 0.3s;\n}\n.fade-enter[data-v-5e3b1b97] {\n  opacity: 0;\n}\n", ""]);

// exports
